import React, { useEffect } from "react";
import { useParams, useRouter } from "next/navigation";
import { api } from "~/utils/api";

export const useCommunity = () => {
    const router = useRouter();
    const params = useParams<{ communitySlug: string }>();
    const slug = params?.communitySlug as string;
    const {
        data: community,
        isError,
        isLoading,
        refetch,
    } = api.community.getBySlug.useQuery(
        {
            slug,
        },
        {
            enabled: !!slug,
        },
    );

    useEffect(() => {
        if (isError) {
            console.error("Community not found");
            router.push("/404");
        }
    }, [community, isError]);

    return {
        community,
        communityLoading: isLoading,
        refetch,
    };
};
